import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'

import { AttributeComponent } from './attribute.component'
import { CustomMaterialModule } from '../material/custom-material.module'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomMaterialModule,
  ],
  declarations: [
    AttributeComponent,
  ],
  exports: [
    AttributeComponent,
  ]
})
export class AttributeModule { }



// WEBPACK FOOTER //
// ./src/app/shared/attribute/attribute.module.ts